import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Banner from './components/Banner';
import Features from './components/Features';
import Steps from './components/Steps';
import Footer from './components/Footer';
import Dashboard from './dashboard/Dashboard';
import DashboardLayout from './dashboard/DashboardLayout';
import MyFolder from './pages/MyFolder';
import MyDocuments from './pages/MyDocuments';
import Bin from './pages/Bin';
import Nft from './pages/Nft';
import Support from './pages/Support';
import ProfilePage from './pages/ProfilePage'; 
import Signup from './pages/Signup';
import Login from './pages/Login';
import AboutUs from './pages/AboutUs';
import Blog from './pages/Blog';

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={
          <>
            <Header />
            <Banner />
            <Features />
            <Steps />
            <Footer />
          </>
        } />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/dashboard" element={
          <DashboardLayout isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}>
            <Dashboard />
          </DashboardLayout>
        } />
        <Route path="/my-folder" element={
          <DashboardLayout isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}>
            <MyFolder />
          </DashboardLayout>
        } />
        <Route path="/my-documents" element={
          <DashboardLayout isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}>
            <MyDocuments />
          </DashboardLayout>
        } />
        <Route path="/bin" element={
          <DashboardLayout isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}>
            <Bin />
          </DashboardLayout>
        } />
        <Route path="/nft" element={
          <DashboardLayout isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}>
            <Nft />
          </DashboardLayout>
        } />
        <Route path="/support" element={
          <DashboardLayout isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}>
            <Support />
          </DashboardLayout>
        } />
        <Route path="/profile" element={
          <DashboardLayout isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}>
            <ProfilePage />
          </DashboardLayout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
